module.exports = __webpack_public_path__ + "media/public/img/linkedin-round-01-4bc9326eb20f8e88ec4be7e8773b84b7.svg";